import { createPortal } from "react-dom";
import { Receipt, X, User } from "lucide-react";
import { useFacturaMismoMes } from "../contexts/FacturaMismoMesContext";

// Alerta parpadeante global de Factura Mismo Mes (idéntica a Atención Prioritaria).
export default function FacturaMismoMesAlert() {
  const { alerta, cerrarAlerta } = useFacturaMismoMes();
  if (!alerta) return null;

  return createPortal(
    <div
      className="ap-alert-overlay"
      data-testid="factura-mes-alert"
      role="alertdialog"
      aria-live="assertive"
      onPointerDown={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <div className="ap-alert-card">
        <button
          className="ap-alert-close"
          onClick={cerrarAlerta}
          data-testid="factura-mes-close"
          aria-label="Cerrar"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="ap-alert-icon">
          <Receipt className="w-9 h-9" />
        </div>
        <h2 className="ap-alert-title" data-testid="factura-mes-title">
          ESTE CLIENTE DEBE RECIBIR SU FACTURA ESTE MES
        </h2>
        <div className="ap-alert-client">
          <User className="w-5 h-5 mr-2 inline-block" />
          <span data-testid="factura-mes-cliente">{alerta.nombre_display}</span>
        </div>
        {alerta.motivo ? (
          <p className="ap-alert-motivo" data-testid="factura-mes-motivo">
            <strong>Motivo:</strong> {alerta.motivo}
          </p>
        ) : null}
        <p className="ap-alert-instr">
          Trabaja esta factura a tiempo: el cliente la solicitó dentro del mismo mes de emisión.
        </p>
        {alerta.marcado_por_nombre ? (
          <p className="ap-alert-by">Marcado por {alerta.marcado_por_nombre}</p>
        ) : null}
        <button
          className="ap-alert-btn"
          onClick={cerrarAlerta}
          data-testid="factura-mes-ok"
        >
          Entendido
        </button>
      </div>
    </div>,
    document.body
  );
}
